import { useCallback } from 'react';
import { getImageThumb, getTiktokProxyImageSrc } from 'lib/utils/platformImage';
import useProxySrc from './business/useProxySrc';

export const usePlatformResourceURL = () => {
  const { getProxyEnable } = useProxySrc();

  const getImageResource = useCallback(
    (source: string, platform: General.PlatformUpperCaseTunnel) => {
      const needProxy = getProxyEnable(source);
      const thumb = getImageThumb(source, platform);

      if (needProxy) {
        return {
          src: getTiktokProxyImageSrc(source),
          thumb: getTiktokProxyImageSrc(thumb),
        };
      }
      return {
        src: source,
        thumb: thumb,
      };
    },
    [getProxyEnable],
  );

  const getVideoResource = useCallback(
    (source: string, platform: General.PlatformUpperCaseTunnel, thumb?: string) => {
      const needProxy = getProxyEnable(source);
      const finalThumb = thumb ? getImageThumb(thumb, platform) : thumb;
      if (needProxy) {
        return {
          src: getTiktokProxyImageSrc(source),
          thumb: finalThumb ? getTiktokProxyImageSrc(finalThumb) : finalThumb,
        };
      }
      return {
        src: source,
        thumb: finalThumb,
      };
    },
    [getProxyEnable],
  );

  return {
    getImageResource,
    getVideoResource,
  };
};
